import { Plane, Building2, MapPin, ArrowDown, ArrowUp, Users, FileQuestion } from 'lucide-react'
import type { AircraftRegistrySummary, SavedViewId } from '@/types/aircrafts'

interface AircraftsFooterProps {
  summary: AircraftRegistrySummary
  activeView: SavedViewId
}

function Separator() {
  return <div className="h-4 w-px bg-border" />
}

function Metric({
  icon: Icon,
  value,
  label,
  colorClass,
}: {
  icon: React.ComponentType<{ className?: string }>
  value: number
  label: string
  colorClass?: string
}) {
  return (
    <div className="flex items-center gap-2">
      <Icon className={`h-4 w-4 ${colorClass ?? 'text-muted-foreground'}`} />
      <span className={`font-medium ${colorClass ?? ''}`}>{value}</span>
      <span className="text-muted-foreground">{label}</span>
    </div>
  )
}

export function AircraftsFooter({ summary, activeView }: AircraftsFooterProps) {
  return (
    <div className="flex items-center justify-between rounded-lg border bg-muted/50 px-4 py-2 text-sm flex-shrink-0">
      {activeView === 'ramp' && (
        <>
          <Metric icon={Plane} value={summary.onFieldCount} label="on field" />
          <Separator />
          <Metric icon={Building2} value={summary.inHangarCount} label="in hangar" />
          <Separator />
          <Metric icon={MapPin} value={summary.onRampCount} label="on ramp" />
          <Separator />
          <Metric icon={ArrowDown} value={summary.arrivingCount} label="arriving" colorClass="text-green-600 dark:text-green-500" />
          <Separator />
          <Metric icon={ArrowUp} value={summary.departingCount} label="departing" colorClass="text-orange-600 dark:text-orange-500" />
        </>
      )}

      {activeView === 'based_fleet' && (
        <>
          <Metric icon={Users} value={summary.basedCount} label="based total" />
          <Separator />
          <Metric icon={Plane} value={summary.onFieldCount} label="on field" />
          <Separator />
          <Metric icon={MapPin} value={summary.awayCount} label="away" />
        </>
      )}

      {activeView === 'transients' && (
        <>
          <Metric icon={Plane} value={summary.onFieldCount} label="on ground" />
          <Separator />
          <Metric icon={ArrowDown} value={summary.arrivingCount} label="arriving" colorClass="text-green-600 dark:text-green-500" />
          <Separator />
          <Metric icon={FileQuestion} value={summary.noContractCount} label="no contract" colorClass="text-yellow-600 dark:text-yellow-500" />
        </>
      )}

      {activeView === 'all' && (
        <>
          <Metric icon={Plane} value={summary.totalAircraft} label="total" />
          <Separator />
          <Metric icon={Users} value={summary.basedCount} label="based" />
          <Separator />
          <Metric icon={ArrowDown} value={summary.transientCount} label="transient" />
        </>
      )}
    </div>
  )
}
